import { buildProps, definePropType, mutable } from '@ll-plus/utils'

import { PaginationProProps } from '@ll-plus/components/pagination-pro'
import { TableHeaderSearchProps } from '@ll-plus/components/table'
import type { ExtractPropTypes } from 'vue'
import type ProTable from '../table.vue'
import { ProMainTableProps } from './index'

// tableProps
export const proTableProps = buildProps({
  /**
   * @description table的loading
   */
  loading: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 头部props
   */
  headerSearchProps: {
    type: definePropType<TableHeaderSearchProps>(Object),
    default: () => mutable({} as const),
  },
  /**
   * @description main-table的props
   */
  tableProps: {
    type: definePropType<ProMainTableProps>(Object),
    default: () => mutable({} as const),
  },
  /**
   * @description 分页的props
   */
  paginationProps: {
    type: definePropType<PaginationProProps>({}),
    default: () => mutable({} as const),
  },
} as const)
// props
export type ProTableProps = ExtractPropTypes<typeof proTableProps>

// instance
export type ProTableInstance = InstanceType<typeof ProTable>
